import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import ContractCheckoutValidator from '../../../common/validation/ContractCheckoutValidator';
import { CheckoutSelector } from '../../../redux/reducers/CheckoutReducer';
import AccountPassword from '../AccountPassword/AccountPassword';
import PreferredConnectionDate from '../PreferredConnectionDate/PreferredConnectionDate';
import ConnectionDateContainer from '../../../redux/containers/ConnectionDateContainer';
import CurrentConnectionContainer from '../../../redux/containers/CurrentConnectionContainer';
import ModemDeliveryContainer from '../../../redux/containers/ModemDeliveryContainer';
import TermsAndConditionsContainer from '../../../redux/containers/TermsAndConditionsContainer';
import CreditAssessmentErrorMessage from '../CreditAssessmentErrorMessage/CreditAssessmentErrorMessage';
import NextButton from '../NextButton/NextButton';
import handleSubmitFail from '../SubmitFailHandler';

const CreditAssessmentStep3 = (props) => {
  const { caSubmitting, caSuccess, caError, handleSubmit, handleNext, handlePrevious, isByoModemSelected } = props;
  return (
    <section>
      <form onSubmit={handleSubmit(handleNext)}>
        <AccountPassword />
        <PreferredConnectionDate />
        <ConnectionDateContainer isSignUpJourney />
        <CurrentConnectionContainer />
        {!isByoModemSelected && <ModemDeliveryContainer />}
        <TermsAndConditionsContainer />
        <CreditAssessmentErrorMessage caError={caError} />
        <NextButton
          submitting={caSubmitting}
          disabled={caSubmitting}
          handlePrevious={handlePrevious}
          success={caSuccess}
        />
      </form>
    </section>
  );
};

const mapStateToProps = state => ({
  caSubmitting: CheckoutSelector.getCaSubmitting(state),
  caError: CheckoutSelector.getCaError(state),
  caSuccess: CheckoutSelector.isCaApproved(state)
});

CreditAssessmentStep3.propTypes = {
  caSubmitting: PropTypes.bool,
  caError: PropTypes.object,
  caSuccess: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleNext: PropTypes.func,
  handlePrevious: PropTypes.func,
  isByoModemSelected: PropTypes.bool
};

export default connect(mapStateToProps)(reduxForm({
  form: 'checkout', // Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,  // unregister fields on unmount
  validate: ContractCheckoutValidator,
  onSubmitFail: err => handleSubmitFail(err)
})(CreditAssessmentStep3));



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CreditAssessmentStep3/CreditAssessmentStep3.js
 **/